import axios from 'axios'

export const unallocateDoor = (doorId, allocationId) => {
    return dispatch => {
        dispatch({ type: 'UNALLOCATE_LOADING', payload: allocationId })
        axios
            .delete(`${window.MYQLOCX_API}/subject/admin/easy_accesses/allocation/easy_access/door/${doorId}`)
            .then(res => {

                dispatch({
                    type: 'UNALLOCATE_SUCCESS',
                    payload: res.data
                })
            })
            .catch(err => {
                dispatch({ type: 'ALLOCATE_FAIL', payload: err.response.data.message })
            })
    }
}

export const _unallocateDoor = (doorId) => {
    return dispatch => {
        dispatch({ type: 'UNALLOCATE_LOADING', payload: doorId })
        axios
            .delete(`${window.MYQLOCX_API}/subject/admin/cluster/allocation/door/${doorId}`)
            .then(res => {

                dispatch({
                    type: 'UNALLOCATE_DOOR_SUCCESS',
                    payload: res.data
                })
            })
            .catch(err => {
                dispatch({ type: 'ALLOCATE_FAIL', payload: err.response.data.message })
            })
    }
}

export const allocateDoor = (lockId, doorId, obj) => {
    if (doorId) {
        return allocateSpecificDoor(doorId, obj)
    } else {
        return allocateRandomDoor(lockId, obj)
    }
}

export const allocateSpecificDoor = (doorId, obj) => {
    return dispatch => {
        dispatch({ type: 'ALLOCATE_LOADING', payload: obj })
        axios
            .post(`${window.MYQLOCX_API}/subject/admin/easy_accesses/door/${doorId}`, obj)
            .then(res => {
                dispatch({
                    type: 'ALLOCATE_SUCCESS',
                    payload: res.data
                })
            })
            .catch(err => {
                dispatch({ type: 'ALLOCATE_FAIL', payload: err.response.data.message })
            })
    }
}

export const allocateRandomDoor = (lockId, obj) => {
    return dispatch => {
        dispatch({ type: 'ALLOCATE_LOADING', payload: obj })
        axios
            .post(`${window.MYQLOCX_API}/subject/admin/easy_accesses/lock/${lockId}`, obj)
            .then(res => {
                dispatch({
                    type: 'ALLOCATE_SUCCESS',
                    payload: res.data,
                    replace: { lockId, allocation_type: obj.allocation_type }
                })
            })
            .catch(err => {
                dispatch({ type: 'ALLOCATE_FAIL', payload: err.response.data.message })
            })
    }
}